import { Middleware } from "@nuxt/types";

import { decodeSharedCollectionHash } from "@/store/shared-wishlists";
import { NOT_FOUND } from "@/utils/enums/http-codes";
import logger, { logLevel } from "@/utils/logger";

const middleware: Middleware = ({ params, $config, $auth, redirect, error }) => {
  const { hash } = params;
  const [, userId] = decodeSharedCollectionHash(hash);

  // A value of null/undefined will allow only the current user by default
  // To disable shared collections, "false" should be used as a config value instead
  // A value of true will enable all collections
  const allowList = $config.wishlists?.sharedCollectionUserAllowList ?? [];

  if (allowList === false) {
    logger(logLevel.DEBUG, "denying access for all shared collections", {
      hash,
      userId,
    });

    return redirect("/");
  }

  if (allowList === true) {
    logger(logLevel.DEBUG, "granting access for all shared collections", {
      hash,
      userId,
    });

    return;
  }

  // Allow looking up shared collections from the allowed list of users, as well as your own
  if (allowList.includes(userId) || userId === $auth.user?.userId) {
    return;
  }

  logger(logLevel.INFO, "attempt to access unauthorized shared collection", {
    hash,
    userId,
    allowList,
    currentUserId: $auth.user?.userId,
  });

  error({ statusCode: NOT_FOUND });
};

export default middleware;
